







































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../../system/mixins";
import { CommonComponentsAccessibleMixin } from "../../../document/editor/mixins";

@Component
export default class ValueConfirmDialog extends Mixins(DialogMixin, CommonComponentsAccessibleMixin) {
  $refs!: {
    textArea: HTMLTextAreaElement,
  };

  data(): any {
    return {
      note: "",
      title: "",
      height: "",
      width: "",
      additionalDescription: "",
      isTextSelected: false,
    };
  }
  isEdit: boolean;
  note: string;
  title: string;
  height: string;
  width: string;
  additionalDescription: string;
  isTextSelected: boolean;

  get dialogWidth(): string {
    return this.width 
    ? this.width 
    : "600px";
  }

  get dialogHeight(): string {
    return this.height
    ? this.height
    : "600px";
  }

  get style(): any {
    return {
      height: this.dialogHeight,
    };
  }

  get isCopyable(): boolean {
    return this.note && this.isTextSelected;
  }

  copy(): void {
    const selectedText = this.$refs.textArea.value.slice(this.$refs.textArea.selectionStart, this.$refs.textArea.selectionEnd);
    this.commonComponents.adapters.clipboard.copy(selectedText);
  }

  onSelectionChange() {
    this.isTextSelected = (this.$refs.textArea && (this.$refs.textArea.selectionStart < this.$refs.textArea.selectionEnd));
  }

  public async show(title: string, note: string, height: string, width: string, additionalDescription: string = ""): Promise<ValueConfirmDialog> {
    return this.showModal(async () => {
      document.addEventListener("selectionchange", this.onSelectionChange);
      this.note = note
        ? note
        : "";
      this.title = title;
      this.height = height;
      this.width = width;
      this.additionalDescription = additionalDescription;
      await this.$nextTick();
      if (this.$refs.textArea && this.note) {
        this.$refs.textArea.select();
      }
      await this.waitHidden();
      document.removeEventListener("selectionchange", this.onSelectionChange);
      return this;
    });
  }

  close(): void {
    this.isVisible = false;
  }
}
